import { useStatsDossiersByStage } from '../../../hooks/queries/useStats';
import {
  DOSSIER_STAGE_LABELS,
  type DossierStage,
} from '../../../services/dossiers/dossierService';

// Couleurs de la charte CIME (verts, ors, neutres), comme la maquette.
const COLORS = ['#043429', '#c9a84c', '#5c8a6b', '#8a6d1f', '#9bb5a3', '#d9c489', '#6b7a70', '#b9c7bd', '#e6dcc0', '#2f5d4a'];

function stageLabel(s: string): string {
  return DOSSIER_STAGE_LABELS[s as DossierStage] ?? s;
}

export function DossiersByStageChart() {
  const { data = [], isLoading, error } = useStatsDossiersByStage();
  const total = data.reduce((sum, d) => sum + Number(d.count), 0);

  if (isLoading) {
    return <p className="text-sm text-cime-text-muted">Chargement…</p>;
  }
  if (error) {
    return <p className="text-sm text-red-600">Erreur de chargement.</p>;
  }
  if (total === 0) {
    return <p className="text-sm text-cime-text-muted">Aucune donnée.</p>;
  }

  const r = 60;
  const C = 2 * Math.PI * r;
  let offset = 0;

  return (
    <div className="flex items-center gap-6">
      <svg width="160" height="160" viewBox="0 0 160 160" className="flex-shrink-0">
        <g transform="translate(80,80) rotate(-90)">
          {data.map((d, i) => {
            const pct = Number(d.count) / total;
            const dash = pct * C;
            const seg = (
              <circle
                key={d.stage}
                r={r}
                cx="0"
                cy="0"
                fill="transparent"
                stroke={COLORS[i % COLORS.length]}
                strokeWidth="22"
                strokeDasharray={`${dash} ${C - dash}`}
                strokeDashoffset={-offset}
              />
            );
            offset += dash;
            return seg;
          })}
        </g>
        <text
          x="80"
          y="80"
          textAnchor="middle"
          dominantBaseline="central"
          className="text-xl font-semibold fill-cime-text-primary"
        >
          {total}
        </text>
      </svg>
      <ul className="text-sm space-y-1">
        {data.map((d, i) => (
          <li key={d.stage} className="flex items-center gap-2">
            <span
              className="inline-block w-3 h-3 rounded-sm"
              style={{ background: COLORS[i % COLORS.length] }}
            />
            <span className="text-cime-text-primary">{stageLabel(d.stage ?? '')}</span>
            <span className="text-cime-text-muted tabular-nums">
              {d.count}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
